import CompanyPageContent from './company-page-content'

const GatherColivingSeo = ({ data }) => {
  const companyData = {
    name: data.name,
    url: data.url,
    about: (
      <>
        Gather Co-living creates modern, shared living spaces by connecting
        like-minded renters with affordable, community-focused housing. Going
        beyond traditional property management,{' '}
        <a
          href="https://www.gathercoliving.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Gather Co-living
        </a>{' '}
        encourages connection and shared responsibility & purpose in their
        properties - built around a core set of values designed to create
        harmonious living spaces. This human-centered approach to renting not
        only allows tenants to find cheaper shared housing, but fosters
        meaningful relationships and inclusive communities built around a common
        goal. With 9 communities in Vancouver, Gather Co-living offers renters a
        variety of living experiences that are united in providing safe,
        inclusive, and affordable rental housing.
      </>
    ),
    faqs: [
      {
        question: 'How does co-living work?',
        answer:
          'Co-living is a type of communal living where renters get their own bedroom in a furnished home with shared common areas. Co-living is ideal for those who are new to town or who want to get a feel for a neighbourhood with more flexibility in terms of a lease, and who want to meet other people who share their values, interests or goals.'
      },
      {
        question: 'Does Gather Co-living allow pets?',
        answer:
          'Unfortunately, the homeowners Gather leases from do not allow pets of any kind on the property.'
      },
      {
        question: 'How long are leases for Gather Co-living properties?',
        answer:
          'Gather Co-living offers a few different lease options. Many renters opt for a full 12-month lease, but we also offer 3-5 month leases for a 10% fee, or a 6-11 month lease for a 5% fee.'
      },
      {
        question: 'What does a room come with?',
        answer:
          'Rooms in Gather Co-living properties come move-in ready with a bed frame, mattress, desk, chair, and closet or wardrobe.'
      },
      {
        question: 'Will I need to pay for utilities?',
        answer:
          'Yes - most Gather Co-living properties have a flat fee ranging from $50-75 for internet, heat, water, and electricity.'
      }
    ]
  }

  return <CompanyPageContent data={companyData} />
}

export default GatherColivingSeo
